export default __webpack_public_path__ + "static/5-2b3953c6abf0293bd52db86f6375d2df.jpg";